var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-image',{style:({ width: _vm.size + 'px', height: 'auto', display: 'inline-block' }),attrs:{"src":require(`@/assets/images/${_vm.icon}.png`)}})
}
var staticRenderFns = []

export { render, staticRenderFns }